import styled, { css } from 'styled-components';
import { selectColor } from '@panel/commons';
import { select } from '@panel/commons/core/themev2';
import InteresadosIcon from '@panel/commons/assets/icons/InteresadosBlue.svg';
import PerformanceGreen from '@panel/commons/assets/icons/performance-green.svg';
import PerformanceYellow from '@panel/commons/assets/icons/performance-yellow.svg';
import PerformanceRed from '@panel/commons/assets/icons/performance-red.svg';
import PerformanceGray from '@panel/commons/assets/icons/performance-black_gris.svg';
import CopyIcon from '@panel/commons/assets/icons/copy-gray.svg';
import InterestedIconBlack from '@panel/commons/assets/icons/user-black.svg';
import AlertIcon from '@panel/commons/assets/icons/AlertNotify.svg';
import AlertIconGrey from '@panel/commons/assets/icons/AlertTriangleGrey.svg';

const TagInDetail = css`
  z-index: 2;
  border-radius: 17.5px;
  font-weight: 600;
  font-size: 14px;
  width: 107px;
  height: 35px;
  top: 12px;
  right: 16px;
`;

const TagInCard = css`
  border-radius: 23px;
  font-weight: 500;
  font-size: 12px;
  width: 71px;
  height: 23px;
  top: 12px;
  left: 14px;
`;

const ReservedTag = styled.span`
  background-color: ${selectColor('feedbackWrong')};
  color: ${selectColor('white')};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  ${({ type }) => (type === 'isDetailCard' ? TagInDetail : TagInCard)}
`;

const StatusActive = css`
  color: ${selectColor('feedbackOk')};
  div {
    background-color: ${selectColor('feedbackOk')};
  }
`;

const StatusFinalized = css`
  color: ${selectColor('feedbackWrong')};
  div {
    background-color: ${selectColor('feedbackWrong')};
  }
`;

const StatusNearEnd = css`
  color: ${select('brownYellow')};
  div {
    background-color: ${select('brownYellow')};
  }
`;

const StatusReserved = css`
  background-color: ${selectColor('reservedOrangeLight')};
  color: ${selectColor('reservedOrange')};
`;

const StatusDefault = css`
  color: ${selectColor('grayDark')};
  div {
    background-color: ${selectColor('grayDark')};
  }
`;

/*
  ONLINE = Activo = Inicio y Vence
  DRAFT = Borrador = Creado
  OFFLINE = Finalizado = Finalizado
  DELETED = Archivado = Archivado
  ON_HOLD = En Espera = SIN FECHA!
  NEAR_END = Por vencer = Inicio y Vence
  WITHOUT_CREDIT = Sin crédito = Finalizado
*/

const statusFilter = status => {
  if (status === 'ONLINE') return StatusActive;
  if (status === 'NEAR_END') return StatusNearEnd;
  if (status === 'OFFLINE' || status === 'WITHOUT_CREDIT') return StatusFinalized;
  return StatusDefault;
};

const StatusTag = styled.span`
  ${({ type }) => statusFilter(type)};
  width: fit-content;
  font-size: ${({ big }) => (big ? '14px' : '12px')};
  max-width: 97px;
  font-weight: 500;
  display: flex;
  align-items: center;
  div {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
  }
`;

const StatusTagFULL = styled.span`
  display: flex;
  min-width: 32px;
  max-width: 250px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid var(--neutral-gray-dividers, #ededed);
  background: #faf5fe;
`;

const InfoWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 18px 0 11px 0;
  > span {
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
`;

const OperationInfo = styled.div`
  color: ${selectColor('grayDark')};
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 16px;
  font-weight: 400;
  line-height: 19px;
  margin-bottom: 8px;
  .operationContainer {
    max-width: 70%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

const TypeSeparator = styled.span`
  margin: 0 4px;
`;

const Amount = styled.div`
  font-size: 12px;
  min-height: 16px;
  font-weight: 500;
  .priceContainer {
    display: flex;
    gap: 3px;
    > span {
      font-weight: 400;
      font-size: 12px;
      color: ${select('darkGray')};
      margin-right: 8px;
    }
  }
`;

const SecondAmount = styled(Amount)`
  margin-top: -5px;
`;

const TitleContainer = styled.div`
  font-weight: 600;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 18px;
`;

const TitleContainerFUll = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${select('black')};
  > span {
    color: ${select('orange')};
  }
`;

const AddressContainer = styled.div`
  font-size: 12px;
  min-height: 16px;
  font-weight: 400;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AddressContainerFull = styled.div`
  color: var(--Neutral-Medium-Dark-Gray, #727272);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const InfoGroup = styled.div`
  font-size: ${({ singleView }) => (singleView ? '16px' : '14px')};
  display: flex;
  > span {
    :first-of-type {
      font-family: 'Hind';
      font-size: ${({ singleView }) => (singleView ? '16px' : '14px')};
      font-weight: 400;
    }
    :nth-of-type(2) {
      color: ${selectColor('grayMediumLight')};
      margin: 0 12px;
    }
  }
`;
const LeadsLink = styled.a`
  display: inline;
  text-decoration: none;
  font-family: 'Hind';
  font-size: ${({ singleView }) => (singleView ? '16px' : '14px')};
  font-style: normal;
  font-weight: 400;
  color: ${selectColor('blue')};
`;

const Posting = styled.div`
  border-top: 1px solid ${selectColor('grayMedium')};
  position: relative;
  height: ${({ isAvailableToConvertToFull }) => (isAvailableToConvertToFull ? '177px' : '145px')};
  width: 100%;
  padding: ${({ isAvailableToConvertToFull }) => (isAvailableToConvertToFull ? '8px 0px 12px 0px' : '0px')};
  display: flex;
  align-items: center;
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding: 0 16px;
  .picture-layout {
    height: inherit;
    display: flex;
    align-items: center;
  }
`;
const MainWrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const InterestedIcon = styled.div`
  position: relative;
  top: ${({ singleView }) => singleView && '2px'};
  margin-right: 5px;
  display: inline-block;
  > span {
    position: absolute;
    border-radius: 8px;
    background-color: ${selectColor('blue')};
    min-height: 16px;
    max-height: 16px;
    min-width: 16px;

    color: white;
    font-family: 'Hind';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;
    top: -6px;
    left: 7px;
  }
  > div {
    background-image: ${`url(${InteresadosIcon})`};
    width: 20px;
    height: 20px;
  }
`;

const TotalInterestedIcon = styled.div`
  display: inline-block;
  background-image: url(${InterestedIconBlack});
  background-repeat: no-repeat;
  background-size: cover;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  position: relative;
  top: 1px;
`;

const PerformanceColors = {
  ALTO: { background: 'positiveBack', color: 'snackGreen', icon: PerformanceGreen },
  MEDIO: { background: 'lightYellow', color: 'brownYellow', icon: PerformanceYellow },
  BAJO: { background: 'redBack', color: 'negative', icon: PerformanceRed },
  'NO-DATA-AVAILABLE': { background: 'middleGray', color: 'midDarkGrayAux', icon: PerformanceGray }
};

const PerformanceStatus = styled.a`
  width: fit-content;
  min-height: 26px;
  display: flex;
  align-items: center;
  text-decoration: none;
  > span {
    display: inline-block;
    background-image: ${({ status }) => status && `url(${PerformanceColors[status].icon})`};
    background-repeat: no-repeat;
    background-size: contain;
    width: 18px;
    height: 16px;
    margin-right: 6px;
  }
  > div {
    font-family: Hind;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    color: ${({ status }) => status && select(PerformanceColors[status].color)};
  }
`;

const CopyButton = styled.span`
  display: inline-block;
  margin-left: 5px;
  content: '';
  background-image: ${`url(${CopyIcon})`};
  background-repeat: no-repeat;
  background-size: cover;
  width: 20px;
  height: 20px;
  left: 0;
  cursor: pointer;
`;

const CollapsibleItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;

  .price {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-weight: 600;
    font-size: 16px;
  }
  .operation {
    font-weight: 400;
    font-size: 14px;
    color: ${select('darkGray')};
  }
`;

const CardBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${select('redBack')};
  height: 26px;
  ${({ hasUncheckedReport }) =>
    !hasUncheckedReport &&
    css`
      background-color: ${select('grayMedium')};
    `}
`;

const ReportMessage = styled.div`
  font-size: 12px;
  font-family: 'Hind';
  color: ${select('negative')};
  display: flex;
  ${({ hasUncheckedReport }) =>
    !hasUncheckedReport &&
    css`
      color: ${select('grayDark')};
    `}
`;

const Alert = styled.div`
  background-image: ${({ hasUncheckedReport }) => `url(${hasUncheckedReport ? AlertIcon : AlertIconGrey})`};
  background-size: contain;
  background-repeat: no-repeat;
  width: 15px;
  height: 15px;
  margin: 0 8px;
`;

const AlertAvailableFull = styled.div`
  background: var(--Violeta-FULL, #330760);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 24px;
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  ${({ isDraftFull }) =>
    isDraftFull &&
    css`
      background: #6b4a8c;
    `}
`;

const LogoFullContainer = styled.img`
  max-width: 80px;
`;

const PropertyType = styled.div`
  color: var(--Neutral-Medium-Dark-Gray, #727272);
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const OperationType = styled.div`
  color: var(--Neutral-Medium-Dark-Gray, #727272);
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const BannerFullCointainer = styled.div`
  border-radius: 8px;
  border: 1px solid var(--neutral-gray-dividers, #ededed);
  background: var(--Light-purple-I24F, #faf5fe);
  display: flex;
  width: 327px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 26px;
`;

const BannerFullTitle = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-top: 24px;
  white-space: break-spaces;
  > span {
    color: ${select('orange')};
  }
`;

const BannerFullSubTitle = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 16px;
  white-space: break-spaces;
`;

const BannerFullCTA = styled.a`
  text-decoration: none;
  border-radius: 8px;
  border: 1px solid ${select('orange')};
  background: var(--Neutral-White, #fff);
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  color: ${select('black')};
  > span {
    color: ${select('orange')};
  }
`;

const ArrowRigthCTA = styled.img`
  margin-bottom: 1px;
`;

const TagZonaDemand = styled.div`
  display: inline-flex;
  min-width: 32px;
  max-width: 250px;
  padding: 0px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: ${select('middleGray')};
  color: ${select('black')};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export {
  MainWrapper,
  Posting,
  InfoGroup,
  StatusTag,
  StatusActive,
  StatusDefault,
  StatusReserved,
  StatusFinalized,
  OperationInfo,
  Amount,
  TitleContainer,
  TypeSeparator,
  AddressContainer,
  InfoWrapper,
  ReservedTag,
  InterestedIcon,
  LeadsLink,
  TotalInterestedIcon,
  PerformanceStatus,
  CopyButton,
  SecondAmount,
  CollapsibleItem,
  CardBanner,
  ReportMessage,
  Alert,
  AlertAvailableFull,
  MainWrapperContainer,
  LogoFullContainer,
  StatusTagFULL,
  PropertyType,
  AddressContainerFull,
  OperationType,
  TitleContainerFUll,
  BannerFullCointainer,
  BannerFullTitle,
  BannerFullSubTitle,
  BannerFullCTA,
  ArrowRigthCTA,
  TagZonaDemand
};
